
const LoadingSpinner = ({classes, wrapper_class}) => {
    return (
        <div className={`w-100 d-flex ${wrapper_class}`}>
            <div className={`spinner-border mx-auto ${classes}`} role="status" aria-hidden="true">
            </div>
        </div> 
    )
}
export default LoadingSpinner